import { Controller } from '@hotwired/stimulus';
import { hideModal, showModal } from '../utils/modal';

export default class TrackController extends Controller {
  static targets = [
    'wrapper',
    'currentAmount',
    'currentAmountModal',
    'remainingAmount',
    'targetAmount',
    'progressBar',
    'emptyGraphic',
    'tickmarkOverlay',
    'updateModal',
    'currentAmountInput',
    'targetAmountModal',
    'targetAmountInput',
    'targetAmountDetail'
  ];

  connect() {
    this.babyStep = this.wrapperTarget.getAttribute('data-baby-step');
    this.basePath =
      this.wrapperTarget.getAttribute('data-base-path') || '/track/baby-step/';

    try {
      this.currentAmount = this.formatAmount(this.currentAmountTarget);
      this.targetAmount = this.formatAmount(this.targetAmountTarget);
      this.updateProgressChart(
        this.calculatePercent(this.currentAmount, this.targetAmount)
      );
    } catch (e) {
      // Safe to ignore because this person doesn't have anything set in the amount
      // But there is no easier way to determine if "this.currentAmountTarget" and "this.targetAmountTarget"
      // won't error out
    }
  }

  showUpdateTargetModal() {
    showModal(this.targetAmountModalTarget.id);
  }

  formatAmount(amount) {
    return Number(amount.innerText.replace(/[^0-9.-]+/g, ''));
  }

  updateCurrentAmount(newCurrentAmount) {
    this.currentAmount = newCurrentAmount;

    if (this.currentAmount >= 0) {
      this.currentAmountTargets.forEach(
        (element) =>
          (element.textContent = `${this.formatValue(this.currentAmount)}`)
      );
      this.remainingAmountTarget.textContent = `${this.formatValue(
        Math.max(this.targetAmount - this.currentAmount, 0)
      )}`;

      hideModal(this.updateModalTarget.id);
      this.currentAmountInputTarget.value = '';
      this.updateProgressChart(
        this.calculatePercent(this.currentAmount, this.targetAmount)
      );
    }
  }

  handleCurrentAmountUpdateSuccess(event) {
    const newCurrentAmount = event.detail[0] && event.detail[0].current_amount;

    this.updateCurrentAmount(newCurrentAmount);
  }

  updateTargetAmount(newTargetAmount) {
    this.targetAmount = newTargetAmount;

    if (this.targetAmount >= 0) {
      // notice the 's' in this.targetAmountTargets. That is intentional to get the multiple instances of the data-target
      // eslint-disable-next-line no-return-assign
      this.targetAmountTargets.forEach(
        (element) =>
          (element.textContent = `${this.formatValue(this.targetAmount)}`)
      );
      this.remainingAmountTarget.textContent = `${this.formatValue(
        Math.max(this.targetAmount - this.currentAmount, 0)
      )}`;

      hideModal(this.targetAmountModalTarget.id);
      this.targetAmountInputTarget.value = '';
      this.updateProgressChart(
        this.calculatePercent(this.currentAmount, this.targetAmount)
      );
    }
  }

  handleTargetAmountUpdateSuccess(event) {
    const newTargetAmount = event.detail[0] && event.detail[0].target_amount;

    this.updateTargetAmount(newTargetAmount);
  }

  updateProgressChart(percent) {
    this.progressBarTarget.style.setProperty('top', `${percent}%`);
    this.progressBarTarget.style.setProperty(
      'transform',
      `translateY(-${percent}%)`
    );
    this.emptyGraphicTarget.style.setProperty('height', `${percent}%`);
    this.tickmarkOverlayTarget.style.setProperty('height', `${percent}%`);
  }

  formatValue(value) {
    const currentStepNumber = Number(this.babyStep);

    if (currentStepNumber === 4) {
      return `${value}%`;
    }

    const formatter = new Intl.NumberFormat('en-us', {
      style: 'currency',
      currency: 'USD',
      maximumSignificantDigits: 6
    });

    return formatter.format(value);
  }

  updateBabyStep(event) {
    location = this.basePath + event.detail[0].baby_step;
  }

  calculatePercent(currentAmount, targetAmount) {
    const percent = Math.min((currentAmount / targetAmount) * 100, 100);
    const remainingPercent = 100 - percent;
    const currentStepNumber = Number(this.babyStep);

    if (currentStepNumber === 6) {
      return percent;
    }

    return remainingPercent;
  }
}
